import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const togglePublishedPlanBreakAfterItemTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "togglePublishedPlanBreakAfterItem",
    onDone: {
      target: "#StudyPlan.get_current_plan"
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("toggleBreakAfterLesson", {
            messageData: ["toggle break after lesson"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
